/**
 * Компонент панели управления таблицей
 */
import { InputNumber, Select, Space, Switch, Tag } from "antd";
import * as React from "react";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import * as styles from "./CustomTableDemo.module.less";
import { User, UserFilters } from "./types";

interface TableControlsProps {
  store: RtStore<User, UserFilters>;
  resizableColumns: boolean;
  onResizableColumnsChange: (value: boolean) => void;
  verticalMode: "fit" | "limit" | "normal";
  onVerticalModeChange: (value: "fit" | "limit" | "normal") => void;
  sortMode: "multi" | "single";
  onSortModeChange: (value: "multi" | "single") => void;
  selectionType: "checkbox" | "radio" | undefined;
  onSelectionTypeChange: (value: "checkbox" | "radio" | undefined) => void;
  fixedLeft: number;
  onFixedLeftChange: (value: number) => void;
  fixedRight: number;
  onFixedRightChange: (value: number) => void;
}

export const TableControls: React.FC<TableControlsProps> = ({
  store,
  resizableColumns,
  onResizableColumnsChange,
  verticalMode,
  onVerticalModeChange,
  sortMode,
  onSortModeChange,
  selectionType,
  onSelectionTypeChange,
  fixedLeft,
  onFixedLeftChange,
  fixedRight,
  onFixedRightChange,
}) => (
  <div className={styles.controls}>
    <div className={styles.controlGroup}>
      <h3>Функционал</h3>
      <Space direction="vertical">
        <Space>
          <Switch
            checked={resizableColumns}
            onChange={onResizableColumnsChange}
          />
          <span>Изменение размера колонок</span>
        </Space>
        <Space>
          <span>Режим высоты:</span>
          <Select
            style={{ width: 120 }}
            value={verticalMode}
            onChange={onVerticalModeChange}
            options={[
              { label: "Fit", value: "fit" },
              { label: "Limit", value: "limit" },
              { label: "Normal", value: "normal" },
            ]}
          />
        </Space>
        <Space>
          <span>Режим сортировки:</span>
          <Select
            style={{ width: 120 }}
            value={sortMode}
            onChange={onSortModeChange}
            options={[
              { label: "Одна колонка", value: "single" },
              { label: "Несколько", value: "multi" },
            ]}
          />
        </Space>
      </Space>
    </div>

    <div className={styles.controlGroup}>
      <h3>Выбор строк</h3>
      <Space direction="vertical">
        <Select
          style={{ width: 150 }}
          placeholder="Selection Type"
          allowClear
          value={selectionType}
          onChange={onSelectionTypeChange}
          options={[
            { label: "Checkbox", value: "checkbox" },
            { label: "Radio", value: "radio" },
          ]}
        />
        {store.selectedKeys.length > 0 && (
          <div>
            Выбрано: <Tag color="blue">{store.selectedKeys.length}</Tag>
          </div>
        )}
      </Space>
    </div>

    <div className={styles.controlGroup}>
      <h3>Фиксированные колонки</h3>
      <Space direction="vertical">
        <Space>
          <span>Слева:</span>
          <InputNumber
            min={0}
            max={3}
            value={fixedLeft}
            onChange={(val) => onFixedLeftChange(val || 0)}
          />
        </Space>
        <Space>
          <span>Справа:</span>
          <InputNumber
            min={0}
            max={3}
            value={fixedRight}
            onChange={(val) => onFixedRightChange(val || 0)}
          />
        </Space>
      </Space>
    </div>

    <div className={styles.controlGroup}>
      <h3>ColumnsSettingsButton</h3>
      <RtColumnsSettingsButton store={store} />
    </div>
  </div>
);
